/**
 * Junção de classes CSS condicionais.
 *
 * Substitui `clsx` sem trazer dependência: o projeto usa Tailwind puro, e a
 * única coisa que faltava era ignorar `false`, `null` e `undefined` no meio da
 * lista.
 */
export type Classe = string | false | null | undefined;

export function cls(...classes: Classe[]): string {
  return classes.filter(Boolean).join(' ');
}
